<template>
  <div class="google-map" :id="mapName"></div>
</template>

<script>
export default {
  name: 'google-map',
  props: ['longitude', 'latitude'],
  data() {
    return {
      mapName: 'googleMap',
      markerCoordinates: [
        { latitude: this.latitude, longitude: this.longitude },
      ],
    };
  },
  methods: {
    setupMap() {
      const element = document.getElementById(this.mapName);
      const options = {
        zoom: 14,
        center: new window.google.maps.LatLng(this.latitude, this.longitude),
        disableDefaultUI: true,
      };
      const map = new window.google.maps.Map(element, options);
      const position = new window.google.maps.LatLng(this.latitude, this.longitude);
      /* eslint no-new: 0 */
      new window.google.maps.Marker({
        position,
        map,
      });
    },
  },
  mounted() {
    this.setupMap();
  },
  watch: {
    latitude() {
      this.setupMap();
    },
    longitude() {
      this.setupMap();
    },
  },
};
</script>

<style lang="scss" scoped>
.google-map {
  width: 100%;
  height: 320px;
  margin: 0 auto;
  background: gray;
  border: 1px solid white;
}

</style>



// WEBPACK FOOTER //
// src/components/googleMap.vue